import { CompetencesTab } from "@features/rh/competences/components/CompetencesTab.tsx";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { Award } from "lucide-react";

export const Route = createFileRoute("/_app/rh/competences/")({
  loader: requirePermission(PERMISSIONS.RH.PERSONNE.VIEW),
  staticData: {
    title: "Compétences",
    icon: Award,
    tab_icon: Award,
    permission: PERMISSIONS.RH.PERSONNE.VIEW,
    module: "rh",
    section: "Ressources Humaines",
    order: 21,
    showInNav: true,
    showInTab: true,
    showInBreadcrumb: true,
    description: "Gestion des compétences",
  },
  component: CompetencesTab,
});
